const lineUtils = {
    partsCount: (machine) => {
        return machine.formatPartsCategories.reduce((acc, arr) => acc + arr.formatParts.length, 0)
    },

    collectAllFormatParts: (line) => {
        const formatPartsList = [];

        line.machines.forEach(machine => {
            machine.formatPartsCategories.forEach(category => {
                category.formatParts.forEach(formatPart => {
                    formatPartsList.push(formatPart);
                });
            });
        });

        return formatPartsList;
    },

    collectAllFormatPartsForMachine: (machine) => {
        const formatPartsList = [];


        machine.formatPartsCategories.forEach(category => {
            category.formatParts.forEach(formatPart => {
                formatPartsList.push(formatPart);
            });
        });


        return formatPartsList;
    }

};


export default lineUtils;
